import { LazyLoadingSectionLogger, LoggingSection } from "@multiweb/logging";
import { IAttrValue } from "@multiweb/types/contracts";
import { StringUtils } from "Global/Base/Utils/StringUtils";
import { IMEChangeGroup, MEAttrChange } from "./types";

const logger = LazyLoadingSectionLogger.create(LoggingSection.multiEditing);

/**
 * Abstraktní třída předka pro skupiny změn
 * @internal
 */
export abstract class MEChangeGroup implements IMEChangeGroup {
    protected _changes: MEAttrChange[] = [];
    protected _excluded: string[] = [];

    public get changes(): readonly MEAttrChange[] {
        return [...this._changes];
    }

    public get excluded(): readonly string[] {
        return this._excluded;
    }
    public get hasChanges(): boolean {
        return this.changes?.length > 0;
    }

    public include(instanceId: string): void {
        this._excluded = this.excluded.filter(i => i !== instanceId);
    }
    public exclude(instanceId: string): void {
        this._excluded.push(instanceId);
    }

    /** Přidá změnu jednoho atributu */
    public addChange(attrName: string, value: IAttrValue): void {
        if (this._changes.length > 0) {
            const latestChange = this._changes[this._changes.length - 1];
            if (StringUtils.compareCaseInsensitive(attrName, latestChange.attrName) && value === latestChange.value) {
                logger.debug(`Attribute '${attrName}' remains unchanged with value of: ${value}`, this);
                return;
            }
        }
        logger.debug(`Attribute '${attrName}' changed. new value: ${value}`, this);
        this._changes.push({ order: this._changes.length, attrName, value });
    }
}
